import md5 from 'md5';

/**
 * Computes the Braze external_id used to identify a user - when calling `braze.changeUser` on
 * the client, when signing the matching SDK Authentication JWT on the server, and when sending
 * REST API events server-side (`braze.server.ts`). All three must compute this identically, or
 * Braze will reject the SDK Authentication signature or split a customer across profiles.
 */
export const getBrazeExternalId = (email: string): string => md5(email.toLowerCase());
